<template>
    <div class="content">
        <v-container fluid height="100%">
            <!-- MICROBIAL/96-WELL-PLATE COMPONENT -->
            <micro-form :microData="microData" :isMicrobial="isMicrobial"></micro-form>
        </v-container>
    </div>
</template>
<script setup lang="ts">
import { ref } from "vue";
import _ from "lodash";
import axios from "@/lib/apiAxios.js";
import MicroForm from "../Wells/MicroForm.vue";

type ExperimentProp = {
    code: string;
};

type ProtocolProp = {
    functionalTeam: string;
}

const {
    experiment,
    protocol
} = defineProps<{
    experiment: ExperimentProp;
    protocol: ProtocolProp
}>();

const microData = ref<unknown[]>([]);
const isMicrobial = ref(false);

async function processDataForPlateDisplay() {
    const microRes = await axios.get(`/experiment/${experiment.code}/plate/layout`);
    const microDataByContainer = _.groupBy(microRes.data, "qr_code");
    const batchData = await axios.get(`/benchling/entitybatchmap`);
    const batchMap = new Map(batchData.data);

    // Hardcoded values for 96-well plate
    let cols = 12;
    let rows = 8;
    const totalWells = cols * rows;
    const plateArray: unknown[] = [];

    // Convert data to 96-well plate and add display fields
    Object.values(microDataByContainer).forEach((plate) => {
        const plateMap = new Array(totalWells).fill({});
        plate.forEach((well) => {
            const rowIndex = well.well_pos.charCodeAt(0) - 65;
            const colIndex = parseInt(well.well_pos.slice(1));
            const plateIndex = rowIndex * cols + colIndex - 1;
            plateMap[plateIndex] = {
                ...well,
                batch: well.batch_id_array
                    ? well.batch_id_array.map((batchId: string) => batchMap.get(batchId))
                    : null,
                concentration: well.concentration ? well.concentration.toString().split(",") : null,
                concentration_units: well.concentration_units
                    ? well.concentration_units.toString().split(",")
                    : null,
            };
        });
        plateArray.push(plateMap);
    });

    microData.value = plateArray;
    isMicrobial.value = protocol.functionalTeam === "Microbial";
}

void processDataForPlateDisplay();

</script>
